import { Button } from 'primereact/button';
import { Card } from 'primereact/card';
import React, { useRef } from 'react';
import Pages from '../../../../../config/Pages';
import ConfirmDialog from '../../../../../core/components/ConfirmDialog';
import ModalIndicador from '../../../indicador/components/modalIndicador/ModalIndicador';
import Header from '../../../indicadorSolicitacoes/components/header/Header';
import ModalPropostaIndicador from '../../../propostaIndicador/components/modalPropostaIndicador/ModalPropostaIndicador';
import styles from './LayoutAnaliseMetas.module.scss';

function LayoutAnaliseMetas({
    children,
    proposta,
    indicador,
    onVoltar = () => {},
    onSalvar = () => {},
    disableSalvar = false,
    classNameChildrenContainer = '',
}) {
    const modalRef = useRef(null);
    const confimRef = useRef(null);

    return (
        <>
            <ConfirmDialog ref={confimRef} isOk />
            {indicador ? (
                <ModalIndicador ref={modalRef} />
            ) : (
                <ModalPropostaIndicador ref={modalRef} />
            )}
            <Card>
                <h5 className={styles.h5}>{Pages.sei.analisePropostaMeta.title}</h5>
                <div className={`p-col-12 p-grid p-fluid ${styles.container}`}>
                    <div className={`p-col-12 ${styles.firstNav}`}>
                        <Header indicador={indicador ?? proposta} modalIndicadorRef={modalRef} />
                    </div>
                    <div className={`p-col-12 ${classNameChildrenContainer}`}>{children}</div>
                    <div className="p-col-12">
                        <div className={`buttonsRight ${styles.actionButtons}`}>
                            <Button
                                label="Voltar"
                                icon="pi pi-arrow-left"
                                iconPos="left"
                                className="p-button-secondary"
                                onClick={() => onVoltar()}
                            />
                            {!disableSalvar && (
                                <>
                                    <Button
                                        label="Salvar"
                                        icon="pi pi-check"
                                        iconPos="left"
                                        type="button"
                                        className="p-button-primary"
                                        onClick={() => onSalvar()}
                                    />
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </Card>
        </>
    );
}

export default LayoutAnaliseMetas;
